export interface NoteLabels {
  showMore: string
  showLess: string
}

export const DEFAULT_NOTE_LABELS: NoteLabels = {
  showMore: 'Show more',
  showLess: 'Show less',
}
